const Specification = () => {

    $(".specification__block").click(function(){
        $(this).find('.specification__img').slideToggle();
        $(this).find('.specification__desc').slideToggle();
        $(this).toggleClass('specification__block--active');
    });
}

export default Specification;


// WEBPACK FOOTER //
// ./src/js/app/components/specification.js